/**
 * WorkspaceProgressBar — thin terracotta bar for the task-question stepper.
 * Also renders the small "Question N of M · N%" caption below.
 */
export default function WorkspaceProgressBar({ current, total }) {
  const pct = total > 0 ? Math.round((current / total) * 100) : 0;
  return (
    <div className="border-b border-neutral-100 bg-white">
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-neutral-100" role="progressbar"
        aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}
        data-testid="workspace-progress">
        <div
          className="h-full rounded-full bg-[#B45309] transition-[width] duration-[250ms] ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="flex items-center justify-between px-4 py-2 text-xs font-medium text-neutral-600 sm:px-6">
        <span data-testid="workspace-progress-label">
          Question {Math.min(current + 1, total)} of {total}
        </span>
        <span className="tabular-nums text-neutral-500">{pct}%</span>
      </div>
    </div>
  );
}
